import type { IconSvgObject } from './types';

const MilkCartonIcon: IconSvgObject = [
  ["path", { d: "M10 22.0002H18C19.1046 22.0002 20 21.1048 20 20.0002V8L17.7322 5.28229C17.5822 5.1025 17.5 4.87576 17.5 4.6416V3C17.5 2.44772 17.0523 2 16.5 2H8C7.44772 2 7 2.44772 7 3V5.00402M20 8L10 8.00024M10 8.00024V22.0002M10 8.00024L7 5.00024L4 8.00024V20.0002C4 21.1048 4.89543 22.0002 6 22.0002H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 13L20 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default MilkCartonIcon;
